var Curriculog = Curriculog || {};

Curriculog.ApprovedQueryParams = (function ($, _, Backbone, ApprovedQueryParams) {

	ApprovedQueryParams = Curriculog.QueryParams.extend({

		defaults: function() {
			return {
				entity: 0,
				includeEntityChildren: 0,
				ap: 0,
				currentStep: {},
				type: '',
				launchedDateRange: {},
				completedDateRange: {},
				exportedDateRange: {},
				originator: 0,
				status: ['completed'],
				name: '',
				permission: '',
				deadline: 0,
				empty: 0,
				flag: '',
				decision: [],
				showCrosslisting: 1
			};
		},

		getDefaultParams: function(exportStatus) {
			// See QueryParams model for explanation of date object

			var defaults = this.defaults();

			if (exportStatus === 'exported') {
				defaults.exportedDateRange = this.validateDateRange({from: '', to: ''});

			} else if (exportStatus === 'not-exported') {
				defaults.completedDateRange = this.validateDateRange({from: '', to: ''});
			}

			return defaults;
		},

		allowedStatuses: function() {
			return this.defaults().status;
		},

		allowedEmpty: function() {
			return false;
		},

		allowedFlag: function() {
			return false;
		},

		allowedDeadline: function() {
			return false;
		}

	});

	return ApprovedQueryParams;

})($, _, Backbone, Curriculog.ApprovedQueryParams || {});